export interface AuthStore {
  isAuth: boolean
  isNotLogged: boolean
  companyId?: number
  personId?: number
}


export const authInitialState: AuthStore = {
  isAuth: false,
  isNotLogged: false,
  companyId: null,
  personId: null
}
